import SidebarList from "../../sidebar/SidebarList";

import "./SidebarStyles.scss";

function Sidebar() {
  return (
    <>
      <div className="sidebar-container">
        <SidebarList />
      </div>
    </>
  );
}

export default Sidebar;
